import React, { useMemo, useCallback } from 'react';
import { connect } from 'react-redux';
import { Icon } from 'antd';
import { FieldType } from './Fields';
import PhotoContainer from './Fields/PhotoContainer';
import Corrections from './Corrections';
import { setCorrection, setField, updateProgress } from '../action_creators';

const sToP = (state, ownProps) => ({
  field: state.fields[ownProps.fieldId],
  status: state.project.status,
  hasCorrection: state.project.intake.corrections && state.project.intake.corrections[ownProps.fieldId] !== undefined,
});

const dToP = (dispatch) => ({
  setCorrectionAction: (id, correction) => dispatch(setCorrection(id, correction)),
  setField: (id, value) => dispatch(setField(id, value)),
  updateProgress: () => dispatch(updateProgress())
});

export function Field({ fieldId, field = {}, hasCorrection, status, setCorrectionAction, setField, updateProgress, provided }) {
  

  const handleChange = useCallback((newValue) => {
    setField(fieldId, { ...field, value: newValue });
    updateProgress(); // Trigger progress update to re-evaluate conditions
  },[fieldId, field, setField, updateProgress]);


  const handleFlagClick = useCallback(() => {
       if (hasCorrection) {
           setCorrectionAction(fieldId); 
       } else {
           setCorrectionAction(fieldId, ''); 
       }
  }, [hasCorrection, fieldId, setCorrectionAction]);

  const borderStyle = useMemo(() => ({
      border: hasCorrection ? '5px solid rgba(255, 0, 0, 0.5)' : 'none' 
  }), [hasCorrection]);

  const iconStyle = useMemo(() => ({
      fontSize: 24,
      color: hasCorrection ? 'red' : 'grey',
      padding: '0.5rem'
    }), [hasCorrection]);

  return (
    <div className="full-width" data-fieldid={fieldId}>
      <div
        className="full-width"
        style={borderStyle}
        data-cy="field"
      >
        <FieldType component={field} onChange={handleChange} />
        <PhotoContainer {...{ provided, fieldId }} />
        {field.comment && (
          <div className="flex-column">
            <div className="bold" style={{ padding: '0.5rem, 0, 0.5rem, 0' }}>
              Field Notes
            </div>
            <div>{field.comment}</div>
          </div>
        )}
        {hasCorrection && <Corrections fieldId={fieldId} />}
      </div>
      <div className="flex-row align-center justify-center">
        {status === 'Review' && (
          <Icon
            className="margin-1"
            style={iconStyle}
            type="flag"
            onClick={handleFlagClick}
          />
        )}
      </div>
    </div>
  );
}

const WrappedField = connect(sToP, dToP)(Field);
export default WrappedField;
